import type { UnitInfoMultislopeScreenInterface } from 'store/units/types';
import { BaseUnitConfig } from 'unitData/BaseUnitConfig';
import type {
  ScreeningMediaInterface,
  MultislopeScreenDeckMapInterface,
} from './MultislopeScreenTypes';
import { MultislopeScreenTypes } from './MultislopeScreenTypes';

/**
 * Samma som för circular
 */
export enum ScreenModels {
  WS6000 = 'WS6000',
  WS6000H = 'WS6000H',
  WN4000WN5000 = 'WN4000_WN5000',
  WN6000 = 'WN6000',
  WN7000H = 'WN7000H',
  WN8000 = 'WN8000',
  WX6000 = 'WX6000',
  WX6500 = 'WX6500',
  WX7000 = 'WX7000',
  WX8500 = 'WX8500',
  WX1000WM = 'WX1000 (WM)',
  WX1000HW = 'WX1000 (HW)',
  WP1000 = 'WP1000',
  SCREENEX_40D = 'Screenex 40D',
  SCREENEX_60D = 'Screenex 60D',
  SCREENEX_65D = 'Screenex 65D',
  SCREENEX_80D = 'Screenex 80D',
}

export const ScreeningMediaDataSM: ScreeningMediaInterface[] = [
  {
    model: ScreenModels.WS6000,
    description: 'Duratuff',
    material: 'Rubber',
    type: 'Self-supporting',
    function: 'Scalping',
    separationSize: {
      metric: '44 - 120',
      imperial: '1.26, 1.73 - 4.72',
    },
    maxFeedSize: {
      metric: '150 - 300',
      imperial: '5.91 - 11.8',
    },
  },
  {
    model: ScreenModels.WS6000H,
    description: 'Ribbtuff',
    material: 'Rubber',
    type: 'Self-supporting',
    function: 'Scalping',
    separationSize: {
      metric: '44 - 120',
      imperial: '1.73 - 4.72',
    },
    maxFeedSize: {
      metric: '250 - 400',
      imperial: '9.84 - 15.8',
    },
  },
  {
    model: ScreenModels.WN4000WN5000,
    description: '',
    material: 'Rubber',
    type: 'Modular',
    function: 'Anti-blinding',
    separationSize: {
      metric: '2 - 25',
      imperial: '0.079 - 0.98',
    },
    maxFeedSize: {
      metric: '20 - 50',
      imperial: '0.787 - 1.97',
    },
  },
  {
    model: ScreenModels.WN6000,
    description: '',
    material: 'Rubber',
    type: 'Modular',
    function: 'Standard',
    separationSize: {
      metric: '8 - 90',
      imperial: '0.315 - 3.54',
    },
    maxFeedSize: {
      metric: '50 - 200',
      imperial: '1.97 - 7.87',
    },
  },
  {
    model: ScreenModels.WN7000H,
    description: '',
    material: 'Rubber',
    type: 'Modular',
    function: 'Heavy duty',
    separationSize: {
      metric: '8 - 90',
      imperial: '0.315 - 3.54',
    },
    maxFeedSize: {
      metric: '50 - 200',
      imperial: '1.97 - 7.87',
    },
  },
  {
    model: ScreenModels.WN8000,
    description: '',
    material: 'PU',
    type: 'Modular',
    function: 'Wet (washing)',
    separationSize: {
      metric: '1 - 34',
      imperial: '0.039 - 1.34',
    },
    maxFeedSize: {
      metric: '20 - 125',
      imperial: '0.787 - 4.92',
    },
  },
  {
    model: ScreenModels.SCREENEX_40D,
    description: '',
    material: 'Rubber',
    type: 'Modular',
    function: 'Anti-Blinding',
    separationSize: {
      metric: '0.6 - 20',
      imperial: '0.0236 - 0.787',
    },
    maxFeedSize: {
      metric: '40',
      imperial: '1.57',
    },
  },
  {
    model: ScreenModels.SCREENEX_60D,
    description: '',
    material: 'Rubber',
    type: 'Modular',
    function: 'Heavy Duty',
    separationSize: {
      metric: '0.5 - 250',
      imperial: '0.0197 - 9.84',
    },
    maxFeedSize: {
      metric: '600',
      imperial: '23.6',
    },
  },
  {
    model: ScreenModels.SCREENEX_65D,
    description: '',
    material: 'PU',
    type: 'Modular',
    function: 'Anti-Blinding',
    separationSize: {
      metric: '0.5 - 20',
      imperial: '0.0197 - 0.787',
    },
    maxFeedSize: {
      metric: '40',
      imperial: '1.57',
    },
  },
  {
    model: ScreenModels.SCREENEX_80D,
    description: '',
    material: 'PU',
    type: 'Modular',
    function: 'Abrasion',
    separationSize: {
      metric: '0.1 - 250',
      imperial: '0.00394 - 9.84',
    },
    maxFeedSize: {
      metric: '600',
      imperial: '23.6',
    },
  },
];

export const filterModels = (
  models: string[],
  nbrOfDecks: number,
): string[] => {
  if (nbrOfDecks === 1) {
    return models.filter((m) => m.charAt(5) === '1');
  } else {
    return models.filter((m) => m.charAt(5) === '2');
  }
};

export const getScreeningMediaData = (
  _screenModel: string,
  _deck: number | undefined,
) => {
  return ScreeningMediaDataSM;
};

export const getScreenFamily = () => {
  return MultislopeScreenTypes.SM;
};

export const MaterialTypes: { name: string; value: string }[] = [
  { name: 'Normal Crushed Stone', value: 'NORMAL_CRUSHED_STONE' },
  { name: 'Cubical Crushed Stone', value: 'CUBICAL_CRUSHED_STONE' },
  { name: 'Uncrushed Sand and Gravel', value: 'UNCRUSHED_SAND_AND_GRAVEL' },
];

export const AvailableInclineDegrees = (_model: string): number[] => {
  return [15];
};

export const AvailableTypeOfApplications: { name: string; value: string }[] = [
  { name: 'Flat deck', value: 'FLAT_DECK' },
  { name: 'Dry sizing', value: 'DRY_SIZING' },
  { name: 'Dry sizing fine <=5mm', value: 'DRY_SIZING_FINE' },
  { name: 'Scalping', value: 'SCALPING' },
  { name: 'Scalping deck 2', value: 'SCALPING_DECK2' },
  { name: 'LRP', value: 'LRP' },
  { name: 'Wet sizing ore', value: 'WET_SIZING_ORE' },
  { name: 'Raw coal: dry sizing', value: 'RAW_COAL' },
  { name: 'Washed coal: wet sizing', value: 'WASHED_COAL' },
  { name: 'Coke', value: 'COKE' },
  { name: 'Sinter', value: 'SINTER' },
  { name: 'Sand washing', value: 'SAND_WASHING' },
];

export const AvailableParticleShapes = [
  '5',
  '10',
  '15',
  '20',
  '30',
  '40',
  '50',
  '60',
  '70',
  '80',
];

export const AvailableEfficiency = [
  //{ value: 'CALC', name: 'Calc' },
  //{ value: 'FULL', name: '100%' },
  { value: 'OTHER', name: 'Other' },
  //{ value: 'QSPEC', name: 'Qspec' },
];

export const Decks: number[] = [1, 2, 3];

export const MotorVoltages = ['400V', '525V', '690V'];

export const ElectricalFrequencies = ['50Hz', '60Hz'];

export const AMBIENT_TEMPERATURE = 'Ambient';

export const InformationOnlyDefaults = {
  isolationFrame: false,
  motorVoltage: MotorVoltages[0],
  electricalFrequency: ElectricalFrequencies[0],
  maxMaterialTemperature: AMBIENT_TEMPERATURE,
  environmentTemperature: AMBIENT_TEMPERATURE,
};

export const InformationOnlyFields: ReadonlySet<string> = new Set(
  Object.keys(InformationOnlyDefaults),
);

/**
 * Returns the default unitinfo object for a Circular Motion Screen
 */
export const getDefaultData = (): UnitInfoMultislopeScreenInterface => {
  const defaultScreeningMedia: ScreeningMediaInterface =
    ScreeningMediaDataSM[5];

  const defaultDeckDisplay = {
    separationSize: true,
    apertureRatio: false,
    model: true,
    openArea: false,
    particleShape: false,
    efficiency: false,
    description: false,
    material: false,
    type: false,
    function: false,
    typeOfApplication: false,
    sprayBar: false,
    maxFeedSize: false,
  };
  const defaultDecks: MultislopeScreenDeckMapInterface = {
    0: {
      separationSize: 50,
      screeningMedia: defaultScreeningMedia,
      screeningElement: defaultScreeningMedia,
      apertureRatio: 1,
      openArea: 50,
      particleShape: AvailableParticleShapes[0].toString(),
      efficiency: AvailableEfficiency[0],
      efficiencyNumber: 95,
      typeOfApplication: AvailableTypeOfApplications[1],
      sprayBar: false,
      display: defaultDeckDisplay,
    },
    1: {
      separationSize: 25,
      screeningMedia: defaultScreeningMedia,
      screeningElement: defaultScreeningMedia,
      apertureRatio: 1,
      openArea: 50,
      particleShape: AvailableParticleShapes[0].toString(),
      efficiency: AvailableEfficiency[0],
      efficiencyNumber: 95,
      typeOfApplication: AvailableTypeOfApplications[1],
      sprayBar: false,
      display: defaultDeckDisplay,
    },
  };

  return {
    nbrOfDecks: 2,
    modelName: 'SM1852',
    sizeOption: '0',
    incline: AvailableInclineDegrees('SM1852')[0],
    materialType: MaterialTypes[0],
    deckList: defaultDecks,
    wetScreening: false,
    parallelUnits: 1,
    deckOneRelieving: false,
    moisture: 0,
    newMoisture: false,
    ...InformationOnlyDefaults,
    display: {
      displayNotes: {
        noteOne: false,
        noteTwo: false,
        noteThree: false,
        noteFour: false,
        noteFive: false,
      },
      displayUnitName: true,
      displayModelName: true,
      displayLoad: true,
      displayNumberOfDecks: false,
      displayWetScreening: false,
    },
  };
};

export class MultislopeScreenConfig extends BaseUnitConfig {
  static getDefaultData(): UnitInfoMultislopeScreenInterface {
    const defaultScreeningMedia: ScreeningMediaInterface =
      ScreeningMediaDataSM[5];

    const defaultDeckDisplay = {
      separationSize: true,
      apertureRatio: false,
      model: true,
      openArea: false,
      particleShape: false,
      efficiency: false,
      description: false,
      material: false,
      type: false,
      function: false,
      typeOfApplication: false,
      sprayBar: false,
      maxFeedSize: false,
    };
    const defaultDecks: MultislopeScreenDeckMapInterface = {
      0: {
        separationSize: 50,
        screeningMedia: defaultScreeningMedia,
        screeningElement: defaultScreeningMedia,
        apertureRatio: 1,
        openArea: 50,
        particleShape: AvailableParticleShapes[0].toString(),
        efficiency: AvailableEfficiency[0],
        efficiencyNumber: 95,
        typeOfApplication: AvailableTypeOfApplications[1],
        sprayBar: false,
        display: defaultDeckDisplay,
      },
      1: {
        separationSize: 25,
        screeningMedia: defaultScreeningMedia,
        screeningElement: defaultScreeningMedia,
        apertureRatio: 1,
        openArea: 50,
        particleShape: AvailableParticleShapes[0].toString(),
        efficiency: AvailableEfficiency[0],
        efficiencyNumber: 95,
        typeOfApplication: AvailableTypeOfApplications[1],
        sprayBar: false,
        display: defaultDeckDisplay,
      },
    };

    return {
      nbrOfDecks: 2,
      modelName: 'SM1852',
      sizeOption: '0',
      incline: AvailableInclineDegrees('SM1852')[0],
      materialType: MaterialTypes[0],
      deckList: defaultDecks,
      wetScreening: false,
      ...BaseUnitConfig.getBaseDefaults(),
      deckOneRelieving: false,
      ...InformationOnlyDefaults,
      display: {
        ...BaseUnitConfig.getDefaultDisplay(),
        displayLoad: true,
        displayRiskLevel: false,
        displayNumberOfDecks: false,
        displayWetScreening: false,
      },
    };
  }

  static getNumberOfPorts(): number {
    return 4;
  }
}

export const multislopeScreenConfig = new MultislopeScreenConfig();
